import Layout from './index'
import accountList from './list4Other'
// import CZJ from './list4CZJ'
import Bind from './save4CZJ'

export default [
  {
    path: '/account',
    name: 'account',
    component: Layout,
    children: [
      {
        path: '/list',
        name: 'account-list',
        component: accountList
      },
      // {
      //   path: '/list4CZJ',
      //   name: 'account-list4CZJ',
      //   component: CZJ
      // },
      {
        path: '/bind',
        name: 'account-bind4CZJ',
        component: Bind
      },
    ]
  },
]
